import { Validator } from "../validator";

export const identityValidator =
  <T>(): Validator<T, T, never> =>
  (value) => ({
    successful: true,
    value,
  });
